import { createHttpChatRepository } from '@myela/ai-core-react/repository';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4003';

export const BOTS_API = `${API_URL}/api/v1/bots`;

// The default fetch sends `credentials: 'include'`, so the session cookie rides
// the cross-origin calls to agent-portal-api.
export const repository = createHttpChatRepository({ basePath: BOTS_API });
